<div class="" style="margin-bottom:15px !important">
    <!--latest news-->
    <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
        <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
            <span style="float:left">{{title}}</span>
        </h6>
    </div>
    <div class="col-xl-12 block-style" style="padding:20px !important;border-top-right-radius:0px; border-top-left-radius:0px">
        <div class="row small-section-content">
            <div (click)="openSubmitDiscussion()" *ngIf="discussions.length == 0" class="col-xl-12 text-center empty" style="cursor:pointer; padding: 20px 0 0 0;cursor:pointer">
                <i class="fas fa-bullhorn"></i>
                <p>Start creating a new discussion</p>
            </div>
            <div *ngFor="let discussion of discussions" (click)="OpenDiscussion(discussion)" class="col-xl-12 no-padding articleTitle" style="padding:10px !important">
                <div class="col-xl-12 no-padding">
                    <a style="overflow-wrap: anywhere;" class="">{{discussion.title}}</a>
                </div>
                <div class="col-xl-12 no-padding feed-time-date" style="opacity:.5">
                    <small>{{discussion.category}} | {{discussion.createdDate | date}}</small>
                </div>
            </div>
            <div class="col-xl-12 text-center" style="margin-top:20px">
                <button style="height:40px" (click)="openDiscussions()" class="btn btn mygistec-btn-outline">all discussions</button>
            </div>
        </div>
    </div>

</div>
